import { inject } from "vue";
export default {
  props: {
    notifCount: Number,
    favoriteCount: Number,
    cartCount: Number
  },
  setup() {
    const {
      drawerOpen
    } = inject("cart");
    return {
      drawerOpen
    };
  }
};